import { http, helper } from '@/http'
import router from '@/router'
const userNameKey = 'ymt_tianji_username'

// initial state
const state = {
  userName: '',
  loginStatus: 0,
  isVIP: false // 是否白名单
}
// getters
const getters = {}
// actions
const actions = {
  geUserinfo ({ commit }, needLogin) {
    if (helper.checkLogin()) {
      commit('setUsername', localStorage.getItem(userNameKey) || '')
      commit('setLoginStatus', 1)
      http.get(`/canmou/tianji/product/is_vip?location_id=20`, {}).then(response => {
        if (response.data.status === 0) {
          commit('updateVipInfo', response.data.isVIP)
        }
      })
    } else {
      commit('setLoginStatus', 2)
      if (needLogin && !/#\/login\b/.test(location.href)) {
        router.replace({
          name: 'login'
        })
      }
    }
  },
  logout ({ commit }) {
    helper.clearSid()
    commit('setUsername', '')
    commit('setLoginStatus', 2)
    if (!/#\/login\b/.test(location.href)) {
      router.replace({
        name: 'login'
      })
    }
  }
}
// mutations
const mutations = {
  setUsername (state, userName) {
    localStorage.setItem(userNameKey, userName)
    state.userName = userName
  },
  setLoginStatus (state, loginStatus) {
    state.loginStatus = loginStatus
  },
  // 是否在白名单
  updateVipInfo (state, isVip) {
    state.isVIP = isVip
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
